"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importStar(require("react"));
var components_1 = __importDefault(require("../components"));
/**
 * Undraw illustration.
 */
var Undraw = /** @class */ (function (_super) {
    __extends(Undraw, _super);
    function Undraw() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Render.
     */
    Undraw.prototype.render = function () {
        var _a = this.props, name = _a.name, rest = __rest(_a, ["name"]);
        var Illustration = components_1.default[name];
        if (!Illustration) {
            // tslint:disable-next-line: no-console
            console.log("Could not find illustration \"" + name + "\"!");
            return null;
        }
        return react_1.default.createElement(Illustration, __assign({}, rest));
    };
    /**
     * Prop types.
     */
    Undraw.propTypes = {
        name: prop_types_1.default.string.isRequired,
        height: prop_types_1.default.string,
        primaryColor: prop_types_1.default.string
    };
    /**
     * Default props.
     */
    Undraw.defaultProps = {
        height: '250px',
        primaryColor: '#6c63ff'
    };
    return Undraw;
}(react_1.Component));
exports.default = Undraw;
